import {get, post, sendAllApi} from "../http"

export default {
    componentList(data) {
        return get('/hbzjt/itemInfo/rest/itemInfo/componentList', data)
    },

    selectzTreeList(data) {
        return get('/hbzjt/itemInfo/rest/itemInfo/dictionary/selectzTreeList', data)
    },
}